export default [
  {
    path: '/active-zy2022/index',
    name: 'index',
    component: () => import('@/views/active-zy2022'),
    meta: {
      title: '2025高考志愿季'
    }
  },
  
]
